import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "n20-container",
    attrs: {
      "fluid": ""
    }
  }, [_c('core-header', {
    attrs: {
      "headline": _vm.$i18n_t('IS.AssetMgmt.assetList'),
      "headerBG": _vm.headerBG
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_c('core-button', {
          attrs: {
            "title": _vm.$i18n_t('IS.AssetMgmt.list.indoor'),
            "color": _vm.color,
            "prepend-icon": "fa-house-return",
            "solid-icon": _vm.indoor
          },
          on: {
            "click": _vm.toggleIndoor
          }
        }), _c('core-button', {
          attrs: {
            "title": _vm.$i18n_t('IS.AssetMgmt.list.outdoor'),
            "color": _vm.color,
            "prepend-icon": "fa-globe-americas",
            "solid-icon": _vm.outdoor
          },
          on: {
            "click": _vm.toggleOutdoor
          }
        }), _c('niota-classic-common-account-filter', {
          attrs: {
            "initiallySelected": _vm.selectedAccounts.map(item => item.id),
            "multiple": ""
          },
          on: {
            "selected": accounts => {
              _vm.selectedAccounts = accounts;
            },
            "reset-filter": _vm.resetFilter
          }
        })];
      },
      proxy: true
    }])
  }), _c('div', [_vm.assetEditDialog ? _c('is-asset-mgmt-edit', {
    attrs: {
      "twinObject": _vm.assetObject
    },
    on: {
      "close": _vm.closeEvent
    }
  }) : _vm._e()], 1), _c(VRow, {
    staticClass: "n20-mainrow",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('core-n20Card', [_c(VRow, {
    staticClass: "py-0 my-0"
  }, [_c(VCol, {
    attrs: {
      "cols": "6",
      "sm": "4",
      "lg": "2"
    }
  }, [_c(VSelect, {
    attrs: {
      "label": _vm.$i18n_t('IS.AssetMgmt.list.searchCategory'),
      "items": _vm.searchCategories,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "hide-details": "",
      "dense": ""
    },
    model: {
      value: _vm.searchItem.category,
      callback: function ($$v) {
        _vm.$set(_vm.searchItem, "category", $$v);
      },
      expression: "searchItem.category"
    }
  })], 1), _c(VCol, [_vm.searchItem.category === 'tag' ? _c(VAutocomplete, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.search'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.categoryList,
      "hide-details": "",
      "clearable": "",
      "dense": ""
    },
    model: {
      value: _vm.searchItem.item,
      callback: function ($$v) {
        _vm.$set(_vm.searchItem, "item", $$v);
      },
      expression: "searchItem.item"
    }
  }) : _vm.searchItem.category === 'zone' ? _c(VAutocomplete, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.search'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.zoneList,
      "hide-details": "",
      "clearable": "",
      "dense": ""
    },
    model: {
      value: _vm.searchItem.item,
      callback: function ($$v) {
        _vm.$set(_vm.searchItem, "item", $$v);
      },
      expression: "searchItem.item"
    }
  }) : _c(VTextField, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.search'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "append-icon": "fal fa-search",
      "hide-details": "",
      "single-line": "",
      "clearable": "",
      "dense": ""
    },
    model: {
      value: _vm.searchItem.item,
      callback: function ($$v) {
        _vm.$set(_vm.searchItem, "item", $$v);
      },
      expression: "searchItem.item"
    }
  })], 1)], 1), _c(VDataTable, {
    attrs: {
      "items": _vm.list,
      "loading": _vm.isFetching,
      "server-items-length": _vm.serverItemsLength,
      "options": _vm.tableOptions,
      "page": _vm.tableOptions.page,
      "headers": _vm.localizedTableOptions.headers,
      "footer-props": _vm.localizedTableOptions.footerProps,
      "item-key": "id",
      "hide-default-header": ""
    },
    on: {
      "update:options": function ($event) {
        _vm.tableOptions = $event;
      },
      "update:page": function ($event) {
        return _vm.$set(_vm.tableOptions, "page", $event);
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function (headerProps) {
        return [_c('thead', {
          staticClass: "v-data-table-header"
        }, [_c('tr', _vm._l(headerProps.props.headers, function (header) {
          return _c('th', {
            key: `asset_table_header_${header.value}`,
            class: _vm.detailTableHeaderColClass(header, headerProps.props)
          }, [header.value === 'category' ? [_vm._v(" ")] : header.value === 'id' ? [_vm._v(" ")] : header.value === 'title' ? [_c('span', {
            class: _vm.detailTableHeaderClasses(headerProps.props).text.title,
            on: {
              "click": function ($event) {
                return headerProps.on.sort(header.value);
              }
            }
          }, [_vm._v("\n                      " + _vm._s(header.text) + "\n                    ")]), _c(VIcon, {
            class: `${_vm.detailTableHeaderClasses(headerProps.props).icon.title}`,
            attrs: {
              "size": "18"
            }
          }, [_vm._v("\n                      fas fa-sort-up\n                    ")]), _vm._v("\n                    /\n                    "), _c('span', {
            class: _vm.detailTableHeaderClasses(headerProps.props).text.id,
            on: {
              "click": function ($event) {
                return headerProps.on.sort('id');
              }
            }
          }, [_vm._v("\n                      " + _vm._s(_vm.$i18n_t('Common.id')) + "\n                    ")]), _c(VIcon, {
            class: `${_vm.detailTableHeaderClasses(headerProps.props).icon.id}`,
            attrs: {
              "size": "18"
            }
          }, [_vm._v("\n                      fas fa-sort-up\n                    ")]), _vm._v("\n                    / (\n                    "), _c('span', {
            staticClass: "header-nonactive"
          }, [_vm._v(_vm._s(_vm.$i18n_t('IS.AssetMgmt.list.category')))]), _vm._v("\n                    )\n                  ")] : header.value === 'floorDtwin.title' ? [_c('span', {
            staticClass: "header-nonactive"
          }, [_vm._v("\n                      " + _vm._s(_vm.$i18n_t('IS.AssetMgmt.list.assetPosition')) + "\n                    ")]), _c('br'), _vm._v("\n                    (\n                    "), _c('span', {
            class: _vm.detailTableHeaderClasses(headerProps.props).text.floorDtwinTitle,
            on: {
              "click": function ($event) {
                return headerProps.on.sort(header.value);
              }
            }
          }, [_vm._v("\n                      " + _vm._s(header.text) + "\n                    ")]), _c(VIcon, {
            class: `${_vm.detailTableHeaderClasses(headerProps.props).icon.floorDtwinTitle}`,
            attrs: {
              "size": "18"
            }
          }, [_vm._v("\n                      fas fa-sort-up\n                    ")]), _vm._v("\n                    )\n                  ")] : [_c('span', {
            on: {
              "click": function ($event) {
                header.sortable ? headerProps.on.sort(header.value) : null;
              }
            }
          }, [_vm._v(_vm._s(header.text))]), header.sortable ? _c(VIcon, {
            staticClass: "v-data-table-header__icon",
            attrs: {
              "size": "18"
            }
          }, [_vm._v("fas fa-sort-up")]) : _vm._e()]], 2);
        }), 0)])];
      }
    }, {
      key: "item",
      fn: function (props) {
        return [_c('tr', [_c('td', {
          staticClass: "px-0 text-center clickable",
          staticStyle: {
            "width": "65px"
          },
          on: {
            "click": function ($event) {
              return _vm.handleRowClick(props.item);
            }
          }
        }, [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "size": "16"
          }
        }, [_vm._v("fal fa-" + _vm._s(props.item.data.faIcon))])], 1), _c('td', {
          staticClass: "clickable",
          staticStyle: {
            "text-overflow": "ellipsis",
            "overflow": "hidden",
            "white-space": "nowrap",
            "max-width": "250px"
          },
          attrs: {
            "colspan": "2"
          },
          on: {
            "click": function ($event) {
              return _vm.handleRowClick(props.item);
            }
          }
        }, [_c('span', {
          staticClass: "mx-2"
        }, [_c('router-link', {
          attrs: {
            "to": `/digitaltwin-mgmt/${props.item.id}`
          }
        }, [_vm._v("\n                    " + _vm._s(props.item.title) + " (" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(props.item.id) + ")\n                  ")]), _vm._v("\n                   \n                  "), _c('a', {
          attrs: {
            "href": `/#/digitaltwin-mgmt/${props.item.id}`,
            "target": "_blank"
          }
        }, [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "size": "12"
          }
        }, [_vm._v("fal fa-external-link")])], 1)], 1), _c('br'), _vm._l(props.item.data.tags, function (tag, i) {
          return _c(VChip, {
            key: `tag_${props.item.id}_${i}`,
            staticClass: "mx-1 my-2",
            attrs: {
              "small": ""
            }
          }, [_vm._v("\n                  " + _vm._s(tag) + "\n                ")]);
        })], 2), _c('td', [(props.item.zones || []).length ? _c(VIcon, {
          attrs: {
            "small": ""
          }
        }, [_vm._v("fal fa-draw-polygon")]) : _vm._e(), _vm._l(props.item.zones, function (zone, i) {
          return _c('span', {
            key: `zone_${props.item.id}_${i}`
          }, [_c('router-link', {
            attrs: {
              "to": `/digitaltwin-mgmt/${zone.id}`
            }
          }, [_vm._v("\n                    " + _vm._s(zone.title) + _vm._s(i < props.item.zones.length - 1 ? ', ' : '') + "\n                  ")])], 1);
        }), (props.item.zones || []).length && props.item.floorDtwinId ? [_c('br'), _c('br')] : _vm._e(), props.item.floorDtwinId ? [_c('router-link', {
          attrs: {
            "to": `/digitaltwin-mgmt/${props.item.floorDtwinId}`
          }
        }, [_c(VIcon, {
          attrs: {
            "size": "12"
          }
        }, [_vm._v("fal fa-level-up-alt")]), _c('span', {
          staticStyle: {
            "font-size": "12px"
          }
        }, [_vm._v(_vm._s((props.item.floorDtwin || {}).title))]), _c('span', {
          domProps: {
            "innerHTML": _vm._s(props.item.floorDtwin ? `<br />(${props.item.floorDtwin.number})` : '')
          }
        })], 1)] : _vm._e()], 2), _c('td', {
          staticClass: "clickable",
          on: {
            "click": function ($event) {
              return _vm.handleRowClick(props.item);
            }
          }
        }, [_vm._v("\n                " + _vm._s(props.item.lastSeen ? _vm.localizeDate(props.item.lastSeen) : '-') + "\n              ")]), _c('td', {
          staticClass: "clickable",
          on: {
            "click": function ($event) {
              return _vm.handleRowClick(props.item);
            }
          }
        }, [_vm._v("\n                " + _vm._s(props.item.data.assetManagement && props.item.data.assetManagement.operationalStatus !== null ? _vm.operationalStatus[parseInt(props.item.data.assetManagement.operationalStatus)] || props.item.data.assetManagement.operationalStatus : _vm.operationalStatus[0]) + "\n              ")]), _c('td', [props.item.device && props.item.device.id ? [_c('router-link', {
          attrs: {
            "to": `/niota-classic/devices/${props.item.device.id}/details`
          }
        }, [_c(VIcon, {
          attrs: {
            "small": ""
          }
        }, [_vm._v("fal fa-sensor-on")]), _vm._v("\n                    " + _vm._s(props.item.device && props.item.device.operationalStatus !== null ? _vm.operationalStatus[parseInt(props.item.device.operationalStatus)] : '-') + "\n                  ")], 1)] : [_vm._v("-")]], 2), _c('td', {
          staticClass: "text-center"
        }, [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.edit'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.handleAssetEdit(props.item);
            }
          }
        }, [_vm._v("\n                  fal fa-edit\n                ")]), _vm._v("\n                 \n                "), _c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.viewDetails'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.$router.push(`/is-assetmgmt/assets/${props.item.id}`);
            }
          }
        }, [_vm._v("\n                  fal fa-eye\n                ")])], 1)])];
      }
    }, {
      key: "footer.page-text",
      fn: function (items) {
        return [_c(VRow, {
          staticClass: "text-center align-center"
        }, [_c(VCol, {
          attrs: {
            "cols": "7",
            "md": "7"
          }
        }, [_vm._v("\n                " + _vm._s(items.pageStart) + "-" + _vm._s(items.pageStop) + " " + _vm._s(_vm.$i18n_t('Common.of')) + " " + _vm._s(items.itemsLength) + "\n              ")]), _c(VCol, {
          attrs: {
            "cols": "5",
            "md": "5"
          }
        }, [_c('niota-classic-common-table-page-selector', {
          attrs: {
            "page": _vm.tableOptions.page,
            "table-max-items": _vm.serverItemsLength,
            "table-items-per-page": _vm.tableOptions.itemsPerPage,
            "title-txt": _vm.$i18n_t('Common.goToPage')
          },
          on: {
            "page-change": function ($event) {
              return _vm.setCurrentTablePage($event);
            }
          }
        })], 1)], 1)];
      }
    }, {
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n            ")])];
      },
      proxy: true
    }])
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };